import { CrmContactWorkbenchFeaturePage } from "..";

/** CRM 联系人工作台路由页面。 */
export function CrmContactWorkbenchPage() {
  return <CrmContactWorkbenchFeaturePage />;
}
